import { AbstractControl } from '@angular/forms';
import { isInteger } from 'lodash';
import * as moment from 'moment';

export class CustomValidator {
    public static NUMBER_REGEXP = /^(?:[0-9])*$/;
    public static POSITIVE_NUMBER_REGEXP = /^[0-9]\d*$/;
    public static POSITIVENUMBERANDDECIMALS_REGEXP = /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/;
    public static FISCAL_CODE_REGEXP = /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/;
    // tslint:disable-next-line:max-line-length
    public static IBAN_REGEXP = /^(?:(?:IT|SM)\d{2}[A-Z]\d{22}|(?:IT|SM)\d{2}[A-Z]\d{10}[A-Z][A-Z]\d{10}|CY\d{2}[A-Z]\d{23}|NL\d{2}[A-Z]{4}\d{10}|LV\d{2}[A-Z]{4}\d{13}|(?:BG|BH|GB|IE)\d{2}[A-Z]{4}\d{14}|GI\d{2}[A-Z]{4}\d{15}|RO\d{2}[A-Z]{4}\d{16}|KW\d{2}[A-Z]{4}\d{22}|MT\d{2}[A-Z]{4}\d{23}|NO\d{13}|(?:DK|FI|GL|FO)\d{16}|MK\d{17}|(?:AT|EE|KZ|LU|XK)\d{18}|(?:BA|HR|LI|CH|CR)\d{19}|(?:GE|DE|LT|ME|RS)\d{20}|IL\d{21}|(?:AD|CZ|ES|MD|SA)\d{22}|PT\d{23}|(?:BE|IS)\d{24}|(?:FR|MR|MC)\d{25}|(?:AL|DO|LB|PL)\d{26}|(?:AZ|HU)\d{27}|(?:GR|MU)\d{28})$/i;
    // tslint:disable-next-line:max-line-length
    public static EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // agenda-availability-form startDateValidator (startDate > today)
    // Almeno una lettera minuscola, Almeno una lettera maiuscola, Almeno un numero, Almeno un carattere speciale tra quelli specificati, Almeno 8 caratteri complessivi
    public static PASSWORD_REGEXP = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&*!?,._-])[A-Za-z\d@#$%^&*!?,._-]{8,}$/;
    public static POSITIVE_NUMBER_REGEXP_EXCLUDING_ZERO = /^[1-9]\d*$/;
    public static PIVA_REGEXP = /^[0-9]{11}$/;


    static startValidator(AC: AbstractControl) {
        const today: Date = new Date;
        if (AC && AC.value && (moment(AC.value).valueOf() < moment(today).valueOf())) {
            return { 'startValidator': true };
        }
        return null;
    }

    // agenda-availability-form endDateValidator (endDate > startDate && endDate > today )
    static endValidator(AC: AbstractControl) {
        const today: Date = new Date;
        let value: boolean = null;
        if (AC) {
            if (AC.parent) {
                if (AC.parent.controls['startDate'].value) {
                    if (moment(AC.value).valueOf() < moment(AC.parent.controls['startDate'].value).valueOf()) {
                        value = true;
                    } else {
                        value = false;
                    }
                }
                if ((AC && AC.value && (moment(AC.value).valueOf() < moment(today).valueOf())) || value) {
                    return { 'endValidator': true };
                }
                return null;
            }
        }
    }

    // agenda-availability-form dateIntervalDateValidator (startDate < endDate)
    static compareValidator(AC: AbstractControl) {
        let start: any = null;
        let end: any = null;
        if (AC) {
            if (AC.parent) {
                if (AC.parent.controls['startDate'].value) {
                    start = moment(AC.parent.controls['startDate'].value).valueOf();
                } else {
                    return;
                }
                if (AC.parent.controls['endDate'].value) {
                    end = moment(AC.parent.controls['endDate'].value).valueOf();
                } else {
                    return;
                }
                if (start > end) {
                    return { 'compareValidator': true };
                } else {
                    return null;
                }
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    static integerNumber(control: AbstractControl) {
        if (control.pristine) {
            return null;
        }

        control.markAsTouched();

        if (CustomValidator.NUMBER_REGEXP.test(control.value)) {
            return null;
        }

        return {
            notValidNumber: true
        };
    }

    static integerPositiveNumberExcludingZero(control: AbstractControl) {
        if (control.pristine) {
            return null;
        }

        control.markAsTouched();

        if (CustomValidator.POSITIVE_NUMBER_REGEXP_EXCLUDING_ZERO.test(control.value)) {
            return null;
        }

        return {
            notValidNumber: true
        };
    }

    static integerPositiveNumber(control: AbstractControl) {
        if (control.pristine) {
            return null;
        }

        control.markAsTouched();

        if (CustomValidator.POSITIVE_NUMBER_REGEXP.test(control.value)) {
            return null;
        }

        return {
            notValidNumber: true
        };
    }

    static onlyPositiveNumber(control: AbstractControl) {
        if (control.pristine) {
            return null;
        }

        control.markAsTouched();

        if (CustomValidator.POSITIVENUMBERANDDECIMALS_REGEXP.test(control.value)) {
            return null;
        }

        return {
            notValidNumber: true
        };
    }

    // agenda-availability-form hourIntervalDateValidator (startHour < endHour)
    static hourValidation(AC: AbstractControl) {
        let start: number = null;
        let end: number = null;
        if (AC) {
            if (AC.parent) {
                if (AC.parent.controls['startHour'].value) {
                    // tslint:disable-next-line:radix
                    start = parseInt(AC.parent.controls['startHour'].value);
                }
                if (AC.parent.controls['endHour'].value) {
                    // tslint:disable-next-line:radix
                    end = parseInt(AC.parent.controls['endHour'].value);
                }
                if (start && end) {
                    if (end < start) {
                        return { 'hourValidation': true };
                    } else {
                        return null;
                    }
                }
                return null;
            }
        }
    }

    // static newHourValidation(AC: AbstractControl) {
    //     let start;
    //     let end;
    //     if (AC) {
    //         if (AC.parent) {
    //             if (AC.parent.controls['startHour'].value) {
    //                 // tslint:disable-next-line:radix
    //                 start = AC.parent.controls['startHour'].value.replace(':', '');
    //             }
    //             if (AC.parent.controls['endHour'].value) {
    //                 // tslint:disable-next-line:radix
    //                 end = AC.parent.controls['endHour'].value.replace(':', '');
    //             }
    //             if (start && end) {
    //                 if (end <= start) {
    //                     return { 'hourValidation': true };
    //                 } else {
    //                     return null;
    //                 }
    //             }
    //             return null;
    //         }
    //     }
    // }

    static newHourValidation(AC: AbstractControl) {
        if (!AC || !AC.parent) return null;

        const startStr: string = AC.parent.get('startHour').value;
        const endStr: string = AC.parent.get('endHour').value;

        if (!startStr || !endStr) return null;

        // Trasformo "HH:mm" in minuti totali per confrontare correttamente
        const [startH, startM] = startStr.split(':').map(Number);
        const [endH, endM] = endStr.split(':').map(Number);

        const startTotal = startH * 60 + startM;
        const endTotal = endH * 60 + endM;

        if (startTotal >= endTotal) {
            return { hourValidation: true };
        }

        return null;
    }

    // agenda-availability-form totalHoursValidator (int > 0)
    static monteOreValidator(AC: AbstractControl) {
        if (AC) {
            if (AC.value) {
                if (AC.value > 0) {
                    if (isInteger(AC.value)) {
                        return null;
                    } else {
                        return { 'monteOreValidator': true };
                    }
                } else {
                    return { 'monteOreValidator': true };
                }
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    static phoneNumber(control: AbstractControl) {
        if (control.pristine) {
            return null;
        }

        control.markAsTouched();

        if (!control.value || (CustomValidator.NUMBER_REGEXP.test(control.value) && control.value && control.value.length >= 9 && control.value.length <= 10)) {
            return null;
        }

        return {
            notValidPhoneNumber: true
        };
    }

    static iban(control: AbstractControl) {
        if (control.pristine) {
            return null;
        }

        control.markAsTouched();

        if (!control.value) {
            return null;
        }

        if (CustomValidator.IBAN_REGEXP.test(control.value)) {
            return null;
        }

        return {
            notValidIban: true
        };
    }

    static emailValidator(control: AbstractControl) {
        if (control.pristine) {
            return null;
        }
        control.markAsTouched();
        if (!control.value) {
            return null;
        }
        if (CustomValidator.EMAIL_REGEXP.test(control.value)) {
            return null;
        }
        return {
            notValidEmail: true
        };
    }

    static passwordValidator(control: AbstractControl) {
        if (control.pristine) {
            return null;
        }
        control.markAsTouched();
        if (!control.value) {
            return null;
        }
        if (CustomValidator.PASSWORD_REGEXP.test(control.value)) {
            return null;
        }
        return {
            notValidPassword: true
        };
    }

    static fiscalCode(control: AbstractControl) {
        if (control.pristine) {
            return null;
        }

        control.markAsTouched();

        if (CustomValidator.FISCAL_CODE_REGEXP.test(control.value)) {
            return null;
        }

        return {
            notValidFiscalCode: true
        };
    }

    static vatNumber(control: AbstractControl) {
        if (control.pristine) {
            return null;
        }

        control.markAsTouched();

        if (CustomValidator.PIVA_REGEXP.test(control.value)) {
            return null;
        }

        return {
            notValidVatNumber: true
        };
    }


    static validJson(control: AbstractControl) {
        if (control.pristine) {
            return null;
        }

        control.markAsTouched();

        let ok = false;
        try {
            const parsed = JSON.parse(control.value);
            if (parsed) {
                ok = true;
            }
        } catch (ex) {
        }

        if (ok) {
            return null;
        }

        return {
            notValidJson: true
        };
    }
}
